import React, { useState, useEffect } from 'react';
import '../styles/PWAUpdatePrompt.css';

export default function PWAUpdatePrompt() {
  const [showPrompt, setShowPrompt] = useState(false);
  const [registration, setRegistration] = useState(null);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showInstallPrompt, setShowInstallPrompt] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState(null);

  useEffect(() => {
    // Слушаем событие обновления SW
    const handleSWUpdate = (event) => {
      setRegistration(event.detail);
      setShowPrompt(true);
    };

    // Слушаем изменение онлайн/офлайн статуса
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    // Слушаем событие установки PWA
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowInstallPrompt(true);
    };

    window.addEventListener('swUpdate', handleSWUpdate);
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    // Проверяем, установлено ли приложение
    if (window.matchMedia('(display-mode: standalone)').matches) {
      setShowInstallPrompt(false);
    }

    return () => {
      window.removeEventListener('swUpdate', handleSWUpdate);
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  const handleUpdate = () => {
    if (registration && registration.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      window.location.reload();
    }
    setShowPrompt(false);
  };

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    
    if (outcome === 'accepted') {
      console.log('PWA установлено');
    }
    
    setDeferredPrompt(null);
    setShowInstallPrompt(false);
  };

  const dismissInstall = () => {
    setShowInstallPrompt(false);
  };

  return (
    <>
      {/* Офлайн индикатор */}
      {!isOnline && (
        <div className="pwa-offline-banner">
          <span className="pwa-offline-icon">📡</span>
          <span>Офлайн режим</span>
        </div>
      )}

      {/* Промпт обновления */}
      {showPrompt && (
        <div className="pwa-update-prompt">
          <div className="pwa-update-content">
            <span className="pwa-update-icon">🔄</span>
            <div className="pwa-update-text">
              <strong>Доступно обновление</strong>
              <p>Новая версия приложения готова</p>
            </div>
            <div className="pwa-update-actions">
              <button onClick={() => setShowPrompt(false)} className="pwa-btn-later">
                Позже
              </button>
              <button onClick={handleUpdate} className="pwa-btn-update">
                Обновить
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Промпт установки */}
      {showInstallPrompt && (
        <div className="pwa-install-prompt">
          <div className="pwa-install-content">
            <span className="pwa-install-icon">♠️</span>
            <div className="pwa-install-text">
              <strong>Установить Poker Ranges</strong>
              <p>Добавить на главный экран для быстрого доступа</p>
            </div>
            <div className="pwa-install-actions">
              <button onClick={dismissInstall} className="pwa-btn-dismiss">
                Не сейчас
              </button>
              <button onClick={handleInstall} className="pwa-btn-install">
                Установить
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}



